import { render, staticRenderFns } from "./SupplierStockLevelConfigurations.vue?vue&type=template&id=63b8da71&"
import script from "./SupplierStockLevelConfigurations.vue?vue&type=script&lang=js&"
export * from "./SupplierStockLevelConfigurations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports